import { dashboardApiBaseUrl } from '../../shared/env';
import { createJsonClient } from '../../shared/httpClient';
import type { DashboardGateway } from './DashboardGateway';
import type { DashboardSummaryResponse, ExecutiveDashboardResponse, ExecutiveQuery, MetricDefinition, SuperAdminDashboardResponse } from './types';

export class HttpDashboardGateway implements DashboardGateway {
  private readonly request = createJsonClient(dashboardApiBaseUrl);

  getSummary(signal?: AbortSignal): Promise<DashboardSummaryResponse> {
    return this.request('/api/dashboard-summary', undefined, signal);
  }

  getExecutiveDashboard(query: ExecutiveQuery, signal?: AbortSignal): Promise<ExecutiveDashboardResponse> {
    const params = new URLSearchParams({ period: query.period });
    if (query.period === 'custom' && query.from && query.to) {
      params.set('from', query.from);
      params.set('to', query.to);
    }
    return this.request(`/api/executive-dashboard?${params.toString()}`, undefined, signal);
  }

  getMetricDictionary(signal?: AbortSignal): Promise<MetricDefinition[]> {
    return this.request('/api/dashboard-metrics', undefined, signal);
  }

  getSuperAdminSummary(signal?: AbortSignal): Promise<SuperAdminDashboardResponse> {
    return this.request('/api/super-admin-dashboard-summary', undefined, signal);
  }
}
